import { UtilService } from './../../../shared/services/util/util.service';
import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-medical-seo',
  templateUrl: './medical-seo.component.html',
  styleUrls: ['./medical-seo.component.scss']
})
export class MedicalSEOComponent implements OnInit {
  isMobile: any;
  @Input() section;

  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }

}
